import { ContactUs, CopyrightFooter } from 'app/components';
import { Container, IAppState } from 'app/containers/Container';
import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const pagePalette = {
  canvas: '#f4f7fb',
  ink: '#315f8f',
  accent: '#e8f1fa',
  border: '#d6e3f2',
  title: '#6d7785',
  text: '#4d5d71',
  glow: '0 22px 48px rgba(16, 53, 87, 0.12)',
};

const sectionCardStyle: React.CSSProperties = {
  background: 'linear-gradient(180deg, #ffffff 0%, #f7fbff 100%)',
  border: `1px solid ${pagePalette.border}`,
  borderRadius: '24px',
  boxShadow: pagePalette.glow,
  padding: '34px 34px 30px',
  minHeight: '100%',
  position: 'relative',
  overflow: 'hidden',
};

const sectionHeadingStyle: React.CSSProperties = {
  color: pagePalette.title,
  fontSize: '2.8rem',
  fontWeight: 700,
  marginTop: 0,
  marginBottom: '28px',
  textDecoration: 'underline',
  textUnderlineOffset: '8px',
  textDecorationThickness: '2px',
  textAlign: 'center',
};

const listStyle: React.CSSProperties = {
  listStyle: 'none',
  padding: 0,
  margin: 0,
};

const itemStyle: React.CSSProperties = {
  marginBottom: '16px',
};

const itemLinkStyle: React.CSSProperties = {
  display: 'block',
  color: pagePalette.ink,
  fontSize: '2.35rem',
  fontWeight: 700,
  lineHeight: '1.25',
  textDecoration: 'none',
  padding: '14px 18px',
  borderRadius: '16px',
  backgroundColor: pagePalette.accent,
  border: `1px solid ${pagePalette.border}`,
  boxShadow: '0 8px 18px rgba(49, 95, 143, 0.08)',
};

const itemTextStyle: React.CSSProperties = {
  ...itemLinkStyle,
  cursor: 'default',
};

class MarketIntelligence extends Container<{}, {}> {
  mapAppStateToContainerState(appState: IAppState): {} {
    return {};
  }

  render() {
    return (
      <section>
        <section className="container margin-y-lg">
          <section
            className="animated fadeIn"
            style={{
              background: `linear-gradient(180deg, #f7f9fc 0%, ${pagePalette.canvas} 100%)`,
              padding: '26px 24px 38px',
              minHeight: '520px',
              borderRadius: '28px',
              position: 'relative',
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: '-60px',
                left: '-30px',
                width: '220px',
                height: '220px',
                borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(52, 116, 177, 0.20) 0%, rgba(52, 116, 177, 0) 72%)',
              }}
            />
            <div
              style={{
                position: 'absolute',
                right: '-50px',
                bottom: '-80px',
                width: '260px',
                height: '260px',
                borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(23, 61, 95, 0.14) 0%, rgba(23, 61, 95, 0) 70%)',
              }}
            />

            <h1
              style={{
                textAlign: 'center',
                color: pagePalette.title,
                fontWeight: 400,
                fontSize: '3.4rem',
                marginTop: '5px',
                marginBottom: '16px',
                position: 'relative',
                zIndex: 1,
              }}
            >
              Market Intelligence
            </h1>

            <p
              style={{
                maxWidth: '760px',
                margin: '0 auto 48px',
                textAlign: 'center',
                color: pagePalette.text,
                fontSize: '1.8rem',
                lineHeight: '1.6',
                position: 'relative',
                zIndex: 1,
              }}
            >
              Explore FoundationMark&apos;s market views, league tables, and intelligence snapshots in one place.
            </p>

            <Row style={{ position: 'relative', zIndex: 1 }}>
              <Col sm={6} xs={12} style={{ marginBottom: '28px' }}>
                <section style={sectionCardStyle}>
                  <h2 style={sectionHeadingStyle}>League Tables</h2>
                  <ul style={listStyle}>
                    <li style={itemStyle}>
                      <Link to="/league-table" style={itemLinkStyle}>
                        Accounting Firms
                      </Link>
                    </li>
                    <li style={itemStyle}>
                      <Link to="/contractors" style={itemLinkStyle}>
                        Contractors
                      </Link>
                    </li>
                    <li style={{ marginBottom: 0 }}>
                      <Link to="/financial-advisory" style={itemLinkStyle}>
                        Financial Advisory
                      </Link>
                    </li>
                  </ul>
                </section>
              </Col>

              <Col sm={6} xs={12} style={{ marginBottom: '28px' }}>
                <section style={sectionCardStyle}>
                  <h2 style={sectionHeadingStyle}>Foundation Intelligence</h2>
                  <ul style={listStyle}>
                    <li style={itemStyle}>
                      <Link to="/new-foundation-formation" style={itemLinkStyle}>
                        New Foundation Formation
                      </Link>
                    </li>
                    <li style={itemStyle}>
                      <Link to="/incoming-contribution-leaders" style={itemLinkStyle}>
                        Incoming Contribution Leaders
                      </Link>
                    </li>
                    <li style={itemStyle}>
                      <Link to="/trustee-compensation" style={itemLinkStyle}>
                        Trustee Compensation
                      </Link>
                    </li>
                    <li style={{ marginBottom: 0 }}>
                      <Link to="/employee-compensation" style={itemLinkStyle}>
                        Employee Compensation
                      </Link>
                    </li>
                  </ul>
                </section>
              </Col>
            </Row>
          </section>
        </section>

        <footer>
          <ContactUs />
          <CopyrightFooter />
        </footer>
      </section>
    );
  }
}

export { MarketIntelligence };



// WEBPACK FOOTER //
// ./src/app/containers/MarketIntelligence/index.tsx